import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';

import { AcademyCatalogComponent } from './catalog/academy-catalog.component';
import { CoursePageComponent } from './course/course-page.component';
import { CourseContentSidebarComponent } from './course/course-content-sidebar/course-content-sidebar.component';
import { LessonDisplayComponent } from './course/lesson-display/lesson-display.component';
import { LessonNavigationComponent } from './course/lesson-navigation/lesson-navigation.component';
import { ImageLightboxComponent } from './course/lesson-display/image-lightbox/image-lightbox.component';

import { QuizChoiceComponent } from './quiz/quiz-choice/quiz-choice.component';
import { QuizProgressComponent } from './quiz/quiz-progress/quiz-progress.component';
import { QuizQuestionComponent } from './quiz/quiz-question/quiz-question.component';
import { QuizContainerComponent } from './quiz/quiz-container/quiz-container.component';
import { QuizResultsContainerComponent } from './quiz/quiz-results-container/quiz-results-container.component';
import { QuizResultItemComponent } from './quiz/quiz-result-item/quiz-result-item.component';

import { AcademyBadgeComponent } from './shared/components/academy-badge/academy-badge.component';
import { AcademyCourseLockedComponent } from './shared/components/academy-course-locked/academy-course-locked.component';
import { AcademyDropdownComponent } from './shared/components/academy-dropdown/academy-dropdown.component';
import { AcademyCourseCardComponent } from './shared/components/academy-course-card/academy-course-card.component';
import { AcademyHeaderComponent } from './shared/components/academy-header/academy-header.component';
import { AcademyPaginationComponent } from './shared/components/academy-pagination/academy-pagination.component';
import { AcademyProgressBarComponent } from './shared/components/academy-progress-bar/academy-progress-bar.component';
import { AcademyTrackCarouselComponent } from './shared/components/academy-track-carousel/academy-track-carousel.component';
import { LessonStatusIconComponent } from './shared/components/lesson-status-icon/lesson-status-icon.component';
import { AcademyCertificationsComponent } from './certifications/academy-certifications.component';
import { CertificationDetailComponent } from './certifications/certification-detail/certification-detail.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UIRouterModule,
    ImageLightboxComponent,
    AcademyCertificationsComponent,
    CertificationDetailComponent,
  ],
  declarations: [
    AcademyCatalogComponent,
    CoursePageComponent,
    CourseContentSidebarComponent,
    LessonDisplayComponent,
    LessonNavigationComponent,

    QuizChoiceComponent,
    QuizProgressComponent,
    QuizQuestionComponent,
    QuizContainerComponent,
    QuizResultsContainerComponent,
    QuizResultItemComponent,

    AcademyBadgeComponent,
    AcademyCourseCardComponent,
    AcademyCourseLockedComponent,
    AcademyDropdownComponent,
    AcademyHeaderComponent,
    AcademyPaginationComponent,
    AcademyProgressBarComponent,
    AcademyTrackCarouselComponent,
    LessonStatusIconComponent,
  ],
  exports: [
    AcademyCatalogComponent,
    CoursePageComponent,
    CourseContentSidebarComponent,
    LessonDisplayComponent,
    LessonNavigationComponent,

    QuizChoiceComponent,
    QuizProgressComponent,
    QuizQuestionComponent,
    QuizContainerComponent,
    QuizResultsContainerComponent,
    QuizResultItemComponent,

    AcademyBadgeComponent,
    AcademyDropdownComponent,
    AcademyCourseCardComponent,
    AcademyCourseLockedComponent,
    AcademyHeaderComponent,
    AcademyPaginationComponent,
    AcademyProgressBarComponent,
    AcademyTrackCarouselComponent,
    LessonStatusIconComponent,
    AcademyCertificationsComponent,
    CertificationDetailComponent,
  ],
})
export class AcademyModule {}
